import { notification } from 'antd';
import { appApi } from 'services/api/api-instance';
import type { SubjectWithDifficulty, UpdateSubjectDifficultyRequest } from './types';

/**
 * Fetches all subjects with their difficulty values
 * @returns Array of subjects with difficulties
 */
export const getAllSubjectDifficulties = (): Promise<SubjectWithDifficulty[]> => {
  return appApi
    .get('/subjects/difficulties')
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить сложности предметов' });
      throw error;
    });
};

/**
 * Updates difficulty values for a specific subject
 * @param subjectId - The subject identifier
 * @param data - Partial difficulty values to update
 * @returns Updated subject with difficulties
 */
export const updateSubjectDifficulty = (
  subjectId: number,
  data: UpdateSubjectDifficultyRequest,
): Promise<SubjectWithDifficulty> => {
  return appApi
    .patch(`/subjects/difficulties/subject/${subjectId}`, data)
    .then((res) => {
      notification.success({ message: 'Сложность предмета обновлена' });
      return res.data;
    })
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить сложность предмета' });
      throw error;
    });
};
